import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaWindowClose } from 'react-icons/fa';

const ModalAtividade = ({ show, onHide, titulo, componente, salvando, codigo_prospecto }) => (
  <Modal size="xl" show={show} backdrop="static" onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>{titulo}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{componente}</Modal.Body>
    {codigo_prospecto && (
      <Modal.Footer>
        <Button
          variant="outline-warning"
          onClick={() => {
            window.location.href = `/prospecto/gestao-crm/${codigo_prospecto}`;
          }}
        >
          Ver Lead
        </Button>
      </Modal.Footer>
    )}
  </Modal>
);

export default ModalAtividade;
